export default __webpack_public_path__ + "static/media/full-bundle-accuchek-white@3x.6ce21531.webp";